// @ts-nocheck
/**
 * Property Schemas Initialization
 * Phase 1: Foundation & Type Safety
 * 
 * Initialize property schemas on app startup
 */

import { propertySchemaRegistry } from '@shared/utils/property-schema-registry';
import { defaultPropertySchemas } from '@shared/schemas/default-property-schemas';
import { ALL_NODE_SCHEMAS } from '@shared/nodes';

/**
 * Initialize all property schemas
 */
export function initializePropertySchemas(): void {
  // Register default schemas
  propertySchemaRegistry.registerSchemas(defaultPropertySchemas);

  // Register all node schemas from shared/nodes
  const nodeSchemas = Object.values(ALL_NODE_SCHEMAS);
  propertySchemaRegistry.registerSchemas(nodeSchemas);

  // console.log(
  //   `[Property Schemas] Initialized ${defaultPropertySchemas.length + nodeSchemas.length} schemas:`,
  //   propertySchemaRegistry.getRegisteredNodeTypes()
  // );
}

/**
 * Get initialization status
 */
export function getPropertySchemasStatus(): {
  initialized: boolean;
  count: number;
  nodeTypes: string[];
} {
  const nodeTypes = propertySchemaRegistry.getRegisteredNodeTypes();
  return {
    initialized: nodeTypes.length > 0,
    count: nodeTypes.length,
    nodeTypes,
  };
}
